import React from 'react';
import { toast } from 'react-toastify';
import { PAYMENT_FAILURE_GUIDANCE as COPY } from '../../constants';
import FeatureFlagService, {
  CHUR_2883_AC2_IMPLEMENT_PERSISTENT_BANNER,
} from '../../services/FeatureFlag';

// CHUR-2882: recovery guidance shown when a donation submit fails.
export const PaymentFailureGuidance: React.FC = () => (
  <div className="payment-failure-guidance">
    <p className="payment-failure-guidance__heading">{COPY.HEADING}</p>
    <p>{COPY.BODY}</p>
    <p>{COPY.OPTIONS_INTRO}</p>
    <ol className="payment-failure-guidance__options">
      <li>{COPY.TRY_ANOTHER_CARD}</li>
      <li>{COPY.OTHER_FORM} ({COPY.OTHER_FORM_LABEL})</li>
      <li>{COPY.PHONE} ({COPY.PHONE_LABEL})</li>
    </ol>
    <p>{COPY.CLOSING}</p>
  </div>
);

export const isPersistentGuidanceEnabled = () =>
  FeatureFlagService.getFlag(
    CHUR_2883_AC2_IMPLEMENT_PERSISTENT_BANNER,
    false
  ) === true;

// CHUR-2883: id of the guidance on screen, so a resubmit can close it. Each
// copy gets its own id; reusing one can drop a new toast while the old one is
// still animating out.
let guidanceToastId: ReturnType<typeof toast.error> | null = null;

export const dismissPaymentFailureGuidance = () => {
  if (guidanceToastId !== null) {
    toast.dismiss(guidanceToastId);
    guidanceToastId = null;
  }
};

export const showPaymentFailureGuidance = () => {
  if (!isPersistentGuidanceEnabled()) {
    return toast.error(<PaymentFailureGuidance />, {
      position: 'top-left',
      className: 'payment-failure-guidance-toast',
    });
  }

  // CHUR-2883: stays until the donor clicks the X or resubmits. Clicking or
  // dragging anywhere else on it, including its links, doesn't close it.
  dismissPaymentFailureGuidance();
  guidanceToastId = toast.error(<PaymentFailureGuidance />, {
    position: 'top-left',
    className:
      'payment-failure-guidance-toast payment-failure-guidance-toast--persistent',
    autoClose: false,
    closeOnClick: false,
    draggable: false,
  });
  return guidanceToastId;
};
